import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { API } from '../../lib/api';
import { formatIDR } from '../../lib/format';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Download } from 'lucide-react';

const MONEY = new Set(['revenue','amount']);

function Report({ type, chart }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/admin/reports/${type}`).then(r => setData(r.data)).catch(()=>{}); }, [type]);
  const download = () => { const token = localStorage.getItem('gta_token'); window.open(`${API}/admin/reports/${type}?export=csv&auth=${token}`, '_blank'); };
  if (!data) return <div className="py-8 text-center text-muted-foreground">Memuat...</div>;
  return (
    <div className="mt-2">
      <div className="flex justify-end mb-3"><Button variant="outline" size="sm" onClick={download} data-testid={`export-${type}`}><Download className="h-4 w-4 mr-1" />Export CSV</Button></div>
      {chart && data.rows.length>0 && (
        <Card className="p-5 mb-4"><ResponsiveContainer width="100%" height={240}><BarChart data={data.rows}><CartesianGrid strokeDasharray="3 3" stroke="#eee" vertical={false} /><XAxis dataKey={data.headers[0]} tick={{fontSize:12}} /><YAxis tick={{fontSize:12}} /><Tooltip /><Bar dataKey={data.headers[1]} fill="hsl(43 74% 52%)" radius={[6,6,0,0]} /></BarChart></ResponsiveContainer></Card>
      )}
      <Card className="p-0 overflow-hidden"><div className="overflow-x-auto"><Table><TableHeader><TableRow>{data.headers.map(h=><TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>{data.rows.map((r,i)=><TableRow key={i}>{data.headers.map(h=><TableCell key={h} className="tabular-nums">{MONEY.has(h)?formatIDR(r[h]):r[h]}</TableCell>)}</TableRow>)}</TableBody></Table></div></Card>
    </div>
  );
}

export default function AdminReports() {
  return (
    <AdminLayout title="Reports">
      <Tabs defaultValue="revenue">
        <TabsList><TabsTrigger value="revenue" data-testid="tab-revenue">Revenue</TabsTrigger><TabsTrigger value="commission">Commission</TabsTrigger><TabsTrigger value="membership">Membership</TabsTrigger><TabsTrigger value="allocation">Allocation</TabsTrigger><TabsTrigger value="withdrawal">Withdrawal</TabsTrigger></TabsList>
        <TabsContent value="revenue"><Report type="revenue" chart /></TabsContent>
        <TabsContent value="commission"><Report type="commission" chart /></TabsContent>
        <TabsContent value="membership"><Report type="membership" chart /></TabsContent>
        <TabsContent value="allocation"><Report type="allocation" chart /></TabsContent>
        <TabsContent value="withdrawal"><Report type="withdrawal" chart /></TabsContent>
      </Tabs>
    </AdminLayout>
  );
}
